import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { api } from "./api/client";

import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    List,
    ListItem,
    ListItemButton
} from "@mui/material";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    ResponsiveContainer
} from "recharts";
import {OpenInNew} from "@material-ui/icons";
import IconButton from "@mui/material/IconButton";
import {Button} from "@material-ui/core";
import {adaptV4Theme, createTheme, ThemeProvider} from "@mui/material/styles";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";

class SatisOzetGrafik extends Component {
    state = {
        yil: new Date().getFullYear().toString(),
        ay: "",
        temsilciler: [],
        seciliTemsilci: "",
        teklifTipi: "",
        grafikData: [],
        siralama: "satis_desc", // varsayılan
        sortOrder: { name: "satis", direction: "desc" },

    };

    componentDidMount() {
        this.temsilcileriGetir();
        this.grafikVerisiGetir();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.yil !== this.state.yil ||
            prevState.seciliTemsilci !== this.state.seciliTemsilci ||
            prevState.ay !== this.state.ay ||
            prevState.teklifTipi !== this.state.teklifTipi
        ) {
            this.grafikVerisiGetir();
            this.temsilcileriGetir();
        }
    }

    temsilcileriGetir = () => {
        api
            .get(`/raporlar/teklif-satis/temsilciler`, { params: { yil: this.state.yil, ay: this.state.ay || undefined } })
            .then((res) => {
                this.setState({ temsilciler: res.data.temsilciler || [],
                    temsilciToplamlari: res.data.temsilci_toplamlari || {},
                });
            });
    };

    grafikVerisiGetir = () => {
        const { yil, ay, seciliTemsilci, teklifTipi } = this.state;
        api.get(`/raporlar/teklif-satis/grafik`, {
            params: {
                yil,
                ay: ay || undefined,
                temsilci: seciliTemsilci || undefined,
                teklif_tipi: teklifTipi || undefined,
            },
        }).then((res) => {
            const data = (res.data || []).map((d) => ({
                ay: `${d.ay}.Ay`,
                ay_index: d.ay,
                mal: parseFloat(d.mal || 0),
                hizmet: parseFloat(d.hizmet || 0),
                teklif: parseFloat(d.teklif || 0),
                yedek_parca: parseFloat(d.yedek_parca || 0),
                sozlesme: parseFloat(d.sozlesme || 0),
                agir_bakim: parseFloat(d.agir_bakim || 0),
                agir_tamir: parseFloat(d.agir_tamir || 0),
                revizyon_guncelleme: parseFloat(d.revizyon_guncelleme || 0),
                toplam: parseFloat(d.toplam || 0),
            }));

            this.setState({ grafikData: data });
        });
    };

    handleBarClick = (data) => {
        if (!data?.activePayload?.[0]) return;

        const clicked = data.activePayload[0].payload;
        const { yil, seciliTemsilci, teklifTipi } = this.state;
        const link = `./teklif-satis-raporu?yil=${yil}&ay=${clicked.ay_index}${
            seciliTemsilci ? `&temsilci=${encodeURIComponent(seciliTemsilci)}` : ""
        }${teklifTipi ? `&teklif_tipi=${encodeURIComponent(teklifTipi)}` : ""}`;

        window.open(link, "_blank");
    };

    openTeklifRaporu = (teklifTipiOverride = "") => {
        const { yil, ay, seciliTemsilci } = this.state;
        const temsilciParam = seciliTemsilci ? `&temsilci=${encodeURIComponent(seciliTemsilci)}` : "";
        const teklifTipiParam = teklifTipiOverride ? `&teklif_tipi=${encodeURIComponent(teklifTipiOverride)}` : "";
        const url = `teklif-satis-raporu?yil=${yil}&ay=${ay}${temsilciParam}${teklifTipiParam}`;
        window.open(url, "_blank");
    };

    ayDegisti = (e) => {
        this.setState({ ay: e.target.value });
    };
    formatYAxis = (value) => {
        if (Math.abs(value) >= 1000000) return `${(value / 1000000).toLocaleString("tr-TR", { maximumFractionDigits: 1 })}M`;
        if (Math.abs(value) >= 1000) return `${(value / 1000).toLocaleString("tr-TR", { maximumFractionDigits: 0 })}K`;
        return value;
    };
    render() {
        const { yil,ay, temsilciler, seciliTemsilci, grafikData,temsilciToplamlari, teklifTipi } = this.state;

        const toplamMalzeme = grafikData.reduce((sum, d) => sum + d.mal, 0);
        const toplamHizmet = grafikData.reduce((sum, d) => sum + d.hizmet, 0);
        const toplamTeklif = grafikData.reduce((sum, d) => sum + d.teklif, 0);
        const toplamYedekParca = grafikData.reduce((sum, d) => sum + d.yedek_parca, 0);
        const toplamSozlesme = grafikData.reduce((sum, d) => sum + d.sozlesme, 0);
        const toplamAgirBakim = grafikData.reduce((sum, d) => sum + d.agir_bakim, 0);
        const toplamAgirTamir = grafikData.reduce((sum, d) => sum + d.agir_tamir, 0);
        const toplamRevizyonGuncelleme = grafikData.reduce((sum, d) => sum + d.revizyon_guncelleme, 0);
        const genelToplam= toplamMalzeme + toplamHizmet;
        const teklifTipToplam = toplamTeklif + toplamYedekParca + toplamSozlesme + toplamAgirBakim + toplamAgirTamir + toplamRevizyonGuncelleme;
        const clickableTotalSx = {
            cursor: 'pointer',
            display: 'inline-block',
            '&:hover': { textDecoration: 'underline' },
        };
        const kolonlar = [
            { name: "temsilci", label: "Temsilci" },
            {
                name: "satis",
                label: "Toplam Satış (€)",
                options: {
                    customBodyRender: (value) =>
                        value.toLocaleString("tr-TR", { minimumFractionDigits: 2 }),
                },
            },
            {
                name: "detay",
                label: "",
                options: {
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        const t = tableData[dataIndex].temsilci;
                        return (
                            <IconButton
                                size="small"
                                style={{
                                    width: '5px',
                                    height: '5px',
                                }}
                                onClick={() =>
                                    window.open(
                                        `/teklif-satis-raporu?temsilci=${encodeURIComponent(t)}&yil=${yil}&ay=${ay}${teklifTipi ? `&teklif_tipi=${encodeURIComponent(teklifTipi)}` : ""}`,
                                        "_blank"
                                    )
                                }
                            >
                                <OpenInNew  style={{
                                    width: '15px',
                                    height: '15px',
                                }}/>
                            </IconButton>
                        );
                    },
                },
            },
        ];
        const tableData = temsilciler.map((t) => ({
            temsilci: t,
            satis: temsilciToplamlari[t] || 0,
        }));
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {

                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"2px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 0.2,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:1
                    },
                    root: {
                        lineHeight:0.2
                    }
                },


            },
        }));

        return (
            <Box display="flex" gap={4} p={3}>
                {/* Sol taraf: filtreler ve temsilciler */}
                <Box minWidth={350}>
                    <FormControl  sx={{ mb: 3 }}>
                        <InputLabel>Yıl</InputLabel>
                        <Select
                            value={yil}
                            label="Yıl"
                            onChange={(e) => this.setState({ yil: e.target.value })}
                        >
                            {Array.from(
                                { length: new Date().getFullYear() - 2022 + 1 },
                                (_, i) => {
                                    const year = 2022 + i;
                                    return (
                                        <MenuItem key={year} value={String(year)}>
                                            {year}
                                        </MenuItem>
                                    );
                                }
                            )}
                        </Select>
                    </FormControl>
                    <FormControl  sx={{ mb: 5 }}>
                        <InputLabel id="demo-simple-select-label">Ay</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.ay}
                            label="Ay"
                            onChange={this.ayDegisti}
                        >
                            <MenuItem key={""} value={""}>
                                Tüm Yıl
                            </MenuItem>
                            {Array.from({ length: 12 }, (_, i) => {
                                const ay = 1 + i;
                                return (
                                    <MenuItem key={ay} value={String(ay)}>
                                        {ay}
                                    </MenuItem>
                                );
                            })}

                        </Select>
                    </FormControl>
                    <FormControl sx={{ mb: 5, minWidth: 160 }}>
                        <InputLabel>Teklif Tipi</InputLabel>
                        <Select
                            value={teklifTipi}
                            label="Teklif Tipi"
                            onChange={(e) => this.setState({ teklifTipi: e.target.value })}
                        >
                            <MenuItem value="">Tümü</MenuItem>
                            <MenuItem value="teklif">Teklif</MenuItem>
                            <MenuItem value="yedek_parca">Yedek Parça</MenuItem>
                            <MenuItem value="sozlesme">Bakım Sözleşmesi</MenuItem>
                            <MenuItem value="agir_bakim">Ağır Bakım</MenuItem>
                            <MenuItem value="agir_tamir">Ağır Tamir</MenuItem>
                            <MenuItem value="revizyon_guncelleme">Revizyon-Güncelleme</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography variant="subtitle1" gutterBottom>
                        Temsilciler
                    </Typography>
                    <ThemeProvider theme={myTheme}>
                        <MUIDataTable
                            title={"Temsilciler"}
                            data={tableData}
                            columns={enhanceColumns(kolonlar)}
                            options={{
                                selectableRows: "none",
                                search: false,
                                pagination: false,
                                onRowClick: (rowData) => {
                                    const temsilci = rowData[0];
                                    this.setState({
                                        seciliTemsilci: temsilci === this.state.seciliTemsilci ? "" : temsilci,
                                    });

                                },
                                sortOrder: this.state.sortOrder,
                                onTableChange: (action, tableState) => {
                                    if (action !== "sort") return;
                                    const sort = tableState.sortOrder || {};
                                    if (!sort.name || !sort.direction) return;
                                    this.setState({ sortOrder: { name: sort.name, direction: sort.direction } });
                                },
                                setRowProps: (row) => {
                                    const temsilci = row[0];
                                    return temsilci === this.state.seciliTemsilci
                                        ? { style: { backgroundColor: "#ffb700" } }
                                        : {};
                                },
                            }}
                        />
                    </ThemeProvider>

                </Box>

                {/* Sağ taraf: grafik */}
                <Box flex={1}>
                    <a
                        style={{
                            cursor: 'pointer',
                            color: 'orange',
                        }}
                        onClick={() => {
                            const temsilciParam = seciliTemsilci ? `&temsilci=${encodeURIComponent(seciliTemsilci)}` : "";
                            const url = `teklif-satis-raporu?yil=${yil}&ay=${ay}${temsilciParam}${teklifTipi ? `&teklif_tipi=${encodeURIComponent(teklifTipi)}` : ""}`;
                            window.open(url, "_blank");
                        }}
                    >
                        <span style={{color:'#333'}}>{this.state.seciliTemsilci}  </span>  {this.state.yil} Listesini Aç  <OpenInNew />
                    </a>

                    <Box sx={{ mt: 1 }}>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu("teklif")}>
                            <strong style={{color:'#1976d2'}}>Teklif:</strong> {toplamTeklif.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu("yedek_parca")}>
                            <strong style={{color:'#9333ea'}}> Yedek Parça:</strong> {toplamYedekParca.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu("sozlesme")}>
                            <strong style={{color:'#0f766e'}}> Bakım Sözleşmesi:</strong> {toplamSozlesme.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu("agir_bakim")}>
                            <strong style={{color:'#8d6e63'}}> Ağır Bakım:</strong> {toplamAgirBakim.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu("agir_tamir")}>
                            <strong style={{color:'#dc2626'}}> Ağır Tamir:</strong> {toplamAgirTamir.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu("revizyon_guncelleme")}>
                            <strong style={{color:'#f59e0b'}}> Revizyon-Güncelleme:</strong> {toplamRevizyonGuncelleme.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom sx={clickableTotalSx} onClick={() => this.openTeklifRaporu()}>
                            <strong> Toplam:</strong> {teklifTipToplam.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €
                        </Typography>
                    </Box>
                    <Typography variant="subtitle1" sx={{ mt: 1, mb: 0.5, fontWeight: "bold" }}>
                        Teklif Tipleri
                    </Typography>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                            data={grafikData}
                            margin={{ top: 20, right: 20, bottom: 20, left: 18 }}
                            onClick={this.handleBarClick}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="ay" />
                            <YAxis width={72} tickFormatter={this.formatYAxis} />
                            <Tooltip
                                content={({ payload, label }) => {
                                    if (!payload || payload.length === 0) return null;
                                    const teklif = payload.find(p => p.dataKey === "teklif")?.value || 0;
                                    const yedekParca = payload.find(p => p.dataKey === "yedek_parca")?.value || 0;
                                    const sozlesme = payload.find(p => p.dataKey === "sozlesme")?.value || 0;
                                    const agirBakim = payload.find(p => p.dataKey === "agir_bakim")?.value || 0;
                                    const agirTamir = payload.find(p => p.dataKey === "agir_tamir")?.value || 0;
                                    const revizyonGuncelleme = payload.find(p => p.dataKey === "revizyon_guncelleme")?.value || 0;
                                    const toplam = teklif + yedekParca + sozlesme + agirBakim + agirTamir + revizyonGuncelleme;
                                    return (
                                        <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: "5px" }}>
                                            <p><strong>{label}</strong></p>
                                            <p style={{color:'#1976d2'}}>Teklif: {teklif.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p style={{color:'#9333ea'}}>Yedek Parça: {yedekParca.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p style={{color:'#0f766e'}}>Bakım Sözleşmesi: {sozlesme.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p style={{color:'#8d6e63'}}>Ağır Bakım: {agirBakim.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p style={{color:'#dc2626'}}>Ağır Tamir: {agirTamir.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p style={{color:'#f59e0b'}}>Revizyon-Güncelleme: {revizyonGuncelleme.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p><strong>Toplam: {toplam.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</strong></p>
                                        </div>
                                    );
                                }}
                            />
                            <Legend />
                            <Bar dataKey="teklif" fill="#1976d2" name="Teklif" />
                            <Bar dataKey="yedek_parca" fill="#9333ea" name="Yedek Parça" />
                            <Bar dataKey="sozlesme" fill="#0f766e" name="Bakım Sözleşmesi" />
                            <Bar dataKey="agir_bakim" fill="#8d6e63" name="Ağır Bakım" />
                            <Bar dataKey="agir_tamir" fill="#dc2626" name="Ağır Tamir" />
                            <Bar dataKey="revizyon_guncelleme" fill="#f59e0b" name="Revizyon-Güncelleme" />
                        </BarChart>
                    </ResponsiveContainer>

                    <Box sx={{ mt: 1 }}>
                        <Typography variant="h7" gutterBottom>
                            <strong style={{color:'#f60'}}>Malzeme:</strong> {toplamMalzeme.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom>
                            <strong style={{color: '#f60'}}> Hizmet:</strong> {toplamHizmet.toLocaleString("tr-TR", {minimumFractionDigits: 2})} € |
                        </Typography>
                        <Typography variant="h7" gutterBottom>
                            <strong style={{color: '#f60'}}> Toplam:</strong> {genelToplam.toLocaleString("tr-TR", {minimumFractionDigits: 2})} €
                        </Typography>
                    </Box>
                    <Typography variant="subtitle1" sx={{ mt: 1, mb: 0.5, fontWeight: "bold" }}>
                        Malzeme / Hizmet
                    </Typography>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                            data={grafikData}
                            margin={{ top: 20, right: 20, bottom: 20, left: 18 }}
                            onClick={this.handleBarClick}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="ay" />
                            <YAxis width={72} tickFormatter={this.formatYAxis} />
                            <Tooltip
                                content={({ payload, label }) => {
                                    if (!payload || payload.length === 0) return null;
                                    const mal = payload.find(p => p.dataKey === "mal")?.value || 0;
                                    const hizmet = payload.find(p => p.dataKey === "hizmet")?.value || 0;
                                    const toplam = mal + hizmet;
                                    return (
                                        <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: "5px" }}>
                                            <p><strong>{label}</strong></p>
                                            <p style={{color:'#1976d2'}}>Malzeme: {mal.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p style={{color:'#ef6c00'}}>Hizmet: {hizmet.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</p>
                                            <p><strong>Toplam: {toplam.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €</strong></p>
                                        </div>
                                    );
                                }}
                            />
                            <Legend />
                            <Bar dataKey="mal" fill="#1976d2" name="Malzeme" />
                            <Bar dataKey="hizmet" fill="#ef6c00" name="Hizmet" />
                         </BarChart>
                    </ResponsiveContainer>
                </Box>
            </Box>
        );
    }
}

export default SatisOzetGrafik;
